import { usePopupNotification } from "Hooks/usePopupNotification";
import React, { createContext, useContext } from "react";

const PopupNotificationContext = createContext();

export function PopupNotificationProvider({ children }) {
  const notification = usePopupNotification();
  return (
    <PopupNotificationContext.Provider value={notification}>
      {children}
      <notification.PopupNotification />
    </PopupNotificationContext.Provider>
  );
}

export function usePopupNotificationContext() {
  return useContext(PopupNotificationContext);
}
